// extracted by mini-css-extract-plugin
module.exports = {"reminder":"style_reminder__6RSCJ","reminder__image":"style_reminder__image__NPdA_","reminder__image--mobile":"style_reminder__image--mobile__wHaff"};